/**
 * Budget settings (FSD 2.2.5 FIN-F06 V04): the materiality threshold.
 */

import type { RouteRecordRaw } from 'vue-router'

import { BUDGET_PERMISSIONS } from '@/modules/budget/permissions'

export const BUDGET_SETTINGS_ROUTES: RouteRecordRaw[] = [
  {
    path: '/budget/settings',
    name: 'budget-settings',
    component: () => import('@/modules/budget/settings/BudgetSettingsView.vue'),
    meta: {
      titleKey: 'budget.routeTitles.budgetSettings',
      permission: BUDGET_PERMISSIONS.versionRead,
    },
  },
]
